
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 24.001c-6.617 0-12-5.383-12-12s5.383-12 12-12 12 5.383 12 12-5.383 12-12 12zm0-23c-6.065 0-11 4.935-11 11s4.935 11 11 11 11-4.935 11-11-4.935-11-11-11z","fill":"#004588"}}),_c('path',{attrs:{"d":"M18 18.501a.5.5 0 01-.354-.146l-4.633-4.632a1.972 1.972 0 01-1.013.278c-1.103 0-2-.897-2-2a2.01 2.01 0 011.5-1.934V6.501a.5.5 0 011 0v3.566a2.01 2.01 0 011.5 1.934c0 .36-.096.707-.279 1.015l4.633 4.632a.5.5 0 01-.354.853zm-6-7.5a1.001 1.001 0 000 2 .992.992 0 00.704-.296l.026-.023a.986.986 0 00.27-.681c0-.551-.448-1-1-1z","fill":"#004588"}})])
          )
        }
      }
    